import styled from "styled-components";
import { Theme } from "theme";

export const Spinner = styled.div`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  border: ${Theme.spinnerBackground};
  border-top: ${Theme.spinnerForeground};
  border-radius: 50%;
  width: 150px;
  height: 150px;
  animation: spin 2s linear infinite;
`;

export const FullPageSpinner = styled(Spinner)`
  border: min(1.5vw, 3vh, 15px) solid #666;
  border-top: min(1.5vw, 3vh, 15px) solid MediumSeaGreen;
  width: min(5vw, 10vh, 50px);
  height: min(5vw, 10vh, 50px);
`;
